import { ValidationModel } from '@max/shared/models/validation-results/validation.model';

export class DisbursementRequestTypeModel extends ValidationModel {

    // Gets or sets the disbursement request type id
    public id: number;

    // Gets or sets the disbursement request type value
    public financeDisbursementRequestTypeValue: string;

    // Gets or sets the disbursement request type display value
    public financeDisbursementRequestTypeDisplayValue: string;

    // Gets or sets the disbursement request type description
    public financeDisbursementRequestTypeDescription: string;

    // Gets or sets the require approval for duplicate flag
    public requireApprovalForDuplicate: boolean;

    // Gets or sets the is allowed for external flag
    public isAllowedForExternal: boolean;

    // Gets or sets the active flag
    public active: boolean;

    // Gets or sets the is manual creation enabled flag
    public isManualCreationEnabled: boolean;

    // Gets or sets the is processing required flag
    public isProcessingRequired: boolean;

    // Gets or sets the updated by
    public updatedBy: string;

    // Gets or sets the updated date
    public updatedDate: Date;

    constructor(json: any) {
        super(json);
        json = this.getBody();

        if (json) {
            this.id = json.id;
            this.financeDisbursementRequestTypeValue = json.financeDisbursementRequestTypeValue;
            this.financeDisbursementRequestTypeDisplayValue = json.financeDisbursementRequestTypeDisplayValue;
            this.financeDisbursementRequestTypeDescription = json.financeDisbursementRequestTypeDescription;
            this.requireApprovalForDuplicate = json.requireApprovalForDuplicate;
            this.isAllowedForExternal = json.isAllowedForExternal;
            this.active = json.active;
            this.isManualCreationEnabled = json.isManualCreationEnabled;
            this.isProcessingRequired = json.isProcessingRequired;
            this.updatedBy = json.updatedBy;
            this.updatedDate = json.updatedDate;
        }
    }
}
